<template>
    <div id="editor-mask">
        <div class="common-dialog" :class="dialogSize">
            <div class="prompt">
                <span class="dialog-message">{{ inputTitle }}</span>
                <input class="dialog-input" type="text" v-model="promptMessage" :placeholder="placeholder">
            </div>
            <div class="button-slot button-group">
                <div class="blue-btn btn-txt dialog-btn" @click="cancel">{{ cancelTxt }}</div>
                <div class="blue-btn btn-txt dialog-btn" @click="confirm">{{ confirmTxt }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import PromptDialog from '../dialogs/PromptDialog.vue';

export default {
    name: "WhiteBoardEditor",
    props: [],
    data: function () {
        return {
            show: false,
            maxLength: 30,
            promptMessage: "",
            inputTitle: "名稱：",
            placeholder: "請輸入白板名稱",
            confirmTxt: "確定",
            cancelTxt: "取消",
        };
    },
    components: {
        PromptDialog
    },
    watch: {
        promptMessage: function (newValue) {
            let arr = newValue.match(/[^\x00-\xff]/ig);
            let length = arr == null ? newValue.length : newValue.length + arr.length;

            if (length > this.maxLength) {
                this.promptMessage = newValue.slice(0, -1);
            }
        }
    },
    methods: {
        confirm() {
            this.$emit("closeEditPage", [
                this.promptMessage
            ]);
            this.promptMessage = "";
        },
        cancel() {
            this.$emit("closeEditPage", []);
            this.promptMessage = "";
        }
    },
    mounted() {

    },
};
</script>

<style scoped>
#editor-mask {
    position: absolute;
    background-color: rgb(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    border: 5px;
    z-index: var(--z-index-white-board-editor);
}

.common-dialog {
    background: white;
    border: rgb(0, 89, 173) 0.2rem solid;
    border-radius: 2rem;
    height: fit-content;
    width: 26vw;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.button-slot {
    margin-bottom: 1rem;
}

.dialog-input {
    height: 1.5rem;
    width: 70%;
    font-size: 1.2rem;
    margin-left: 0.5rem;
}

.dialog-input::placeholder {
    font-size: 1rem;
}

.prompt {
    display: flex;
    justify-content: center;
    align-items: baseline;
    margin-top: 30px;
    margin-bottom: 20px;
}
</style>